import { RouterProvider } from 'react-router-dom';
import routes from './router';
import './App.css';
import UserProvider from './providers/UserProvider';
import WalletProvider from './providers/WalletProvider';

function App() {
  return (
    <UserProvider>
      <WalletProvider>
        <RouterProvider
          router={routes}
          fallbackElement={''}
          future={{ v7_startTransition: true }}
        />
      </WalletProvider>
    </UserProvider>
  );
}

export default App;
